import { Injectable } from '@angular/core';
import { ProductGroup } from '../models/products-group';
import { Observable, of } from 'rxjs';
import { ProductStockInformation } from '../models/product-stock-information';
import { Category } from '../models/category';


@Injectable()
export class ProductsService {

  get allProducts(): Observable<ProductGroup[]> {
    return of();
  }

  checkIsAvailableProductOnStock(stockProductRequestQuantity: ProductStockInformation[]): Observable<ProductStockInformation[]> {
    return of();
  }

  checkProductPin(productId: number, pin: string): Observable<boolean> {
    return of();
  }

  get categories(): Observable<Category[]> {
    return of();
  }

  findVariantProductByPin(pin: string, productTemplateId: number): Observable<number> {
    return of();
  }
}
